export default {
  'monitor.online.query.nickname.label': '用户昵称',
  'monitor.online.query.nickname.placeholder': '请输入用户昵称',
  'monitor.online.query.search': '查询',
  'monitor.online.query.reset': '重置',
  'monitor.online.column.username': '登录名',
  'monitor.online.column.nickname': '用户昵称',
  'monitor.online.column.deptName': '部门',
  'monitor.online.column.loginIp': '登录IP',
  'monitor.online.column.loginRegion': '登录地点',
  'monitor.online.column.loginTime': '登录时间',
  'monitor.online.column.browser': '浏览器',
  'monitor.online.column.os': '操作系统',
  'monitor.online.column.operation': '操作',
  'monitor.online.column.operation.logout': '强制注销',
  'monitor.online.column.operation.kickout': '踢Ta下线',
  'monitor.online.logout.confirm': '确认要强制注销"{username}"吗？',
  'monitor.online.logout.title': '提示',
  'monitor.online.logout.confirmButtonText': '确定',
  'monitor.online.logout.cancelButtonText': '取消',
  'monitor.online.logout.success': '强制注销Ta下线成功',
  'monitor.online.kickout.confirm': '确认要踢"{username}"下线吗？',
  'monitor.online.kickout.title': '提示',
  'monitor.online.kickout.confirmButtonText': '确定',
  'monitor.online.kickout.cancelButtonText': '取消',
  'monitor.online.kickout.success': '踢Ta下线成功',
}
